import { render, staticRenderFns } from "./CadastroAcessoPerfil.vue?vue&type=template&id=54a95bce&scoped=true&class=template&"
import script from "./CadastroAcessoPerfil.vue?vue&type=script&lang=js&"
export * from "./CadastroAcessoPerfil.vue?vue&type=script&lang=js&"
import style0 from "./CadastroAcessoPerfil.vue?vue&type=style&index=0&id=54a95bce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a95bce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VRow})
